import { createReducer } from 'store/helpers';
import {
  SET_ERROR,
  CLEAR_ERROR,
  REQUEST_STARTED,
  REQUEST_COMPLETED,
  SET_UNSUBSCRIBED_DOMAINS,
  SET_UNSUBSCRIBED_EMAILS,
} from 'store/actions/domains';
import { addIdPrefix } from 'services/common';

const initialState = {
  domains: [],
  emails: [],
  error: null,
};

const objectToArray = obj => {
  const result = [];
  for (const [key, value] of Object.entries(obj)) {
    result.push(value);
  }
  return result;
};
const setError = (state, { error }) =>
  state.merge({ error: addIdPrefix(error) });

const clearError = state => state.merge({ error: '' });

const requestStarted = state => state.merge({ isFetching: true });

const requestCompleted = state => state.merge({ isFetching: false });

const setUnsubscribedDomains = (state, { domains }) =>
  state.merge({ domains: objectToArray(domains) });

const setUnsubscribedEmails = (state, { emails }) =>
  state.merge({ emails: emails });

const handlers = {
  [SET_ERROR]: setError,
  [CLEAR_ERROR]: clearError,
  [REQUEST_STARTED]: requestStarted,
  [REQUEST_COMPLETED]: requestCompleted,
  [SET_UNSUBSCRIBED_DOMAINS]: setUnsubscribedDomains,
  [SET_UNSUBSCRIBED_EMAILS]: setUnsubscribedEmails,
};

export default createReducer(initialState, handlers);
